<template>
  <div class="app" id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  mounted() {
    window.addEventListener('hashchange', () => {
      this.$pageManager.showInit()
    })
  }
}
</script>

<style lang="stylus">
 @import "~@/assets/style/common.styl"
</style>
